import { useState, useCallback } from 'react';
import { useDataProvider, useNotify, useRefresh, useTranslate } from 'react-admin';

const useActivityCommentEdit = ({ record, isMobile, onToggleActions, resource }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const translate = useTranslate();
    const [isEditing, setIsEditing] = useState(false);
    const isServiceInspection = globalThis.location.pathname.includes('/service-inspection');
    const handleStartEdit = useCallback(
        event => {
            if (event) {
                event.stopPropagation();
            }
            setIsEditing(true);
        },
        [setIsEditing],
    );

    const handleCancelEdit = useCallback(() => {
        setIsEditing(false);
        if (isMobile && record?.id) {
            onToggleActions(record.id);
        }
    }, [isMobile, onToggleActions, record?.id]);

    const handleSaveEdit = useCallback(
        async values => {
            const htmlContent = values.value || '';

            try {
                await dataProvider.put(`${resource}/${isServiceInspection ? record.serviceInspectionId : record.serviceRequestId}/change/${record.id}`, {
                    data: {
                        value: htmlContent,
                    },
                });

                setIsEditing(false);
                if (isMobile) {
                    onToggleActions(record.id);
                }
                refresh();
            } catch (error) {
                notify(error?.body?.message || translate('common.errorOccurred'), { type: 'error' });
            }
        },
        [dataProvider, isMobile, notify, onToggleActions, record, refresh, translate, resource, isServiceInspection],
    );

    return {
        isEditing,
        handleStartEdit,
        handleCancelEdit,
        handleSaveEdit,
        setIsEditing,
        resource,
    };
};

export default useActivityCommentEdit;
